<template>
  <div>
    <el-table
      :data="rows"
      @sort-change="doChangeSort"
      ref="table"
      row-key="id"
      v-loading="loading"
    >
      <!-- <el-table-column type="selection" width="55"></el-table-column> -->

      <el-table-column v-if="hasPermissionToAuditLogs" :label="fields.id.label"  :prop="fields.id.name">
        <template slot-scope="scope">{{ presenter(scope.row, 'id') }}</template>
      </el-table-column>

      <el-table-column
        :label="fields.name.label"
        :prop="fields.name.name"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'name') }}</template>
      </el-table-column>

      <el-table-column
        :label="fields.createdAt.label"
        :prop="fields.createdAt.name"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'createdAt') }}</template>
      </el-table-column>

      <el-table-column :fixed="isMobile? undefined : 'right'" align="center" width="180">
        <template slot-scope="scope">
          <div class="table-actions">
            <router-link :to="`/season/${scope.row.id}/edit`" v-if="hasPermissionToEdit">
              <el-button icon="icon-pen" circle/>
            </router-link>

            <el-button
              :disabled="destroyLoading"
              @click="doDestroyWithConfirm(scope.row.id)"
              circle
              v-if="hasPermissionToDestroy"
              icon="icon-trash"
            />
          </div>
        </template>
    
      </el-table-column>
    </el-table>

    <div class="el-pagination-wrapper">
      <el-pagination
        :current-page="pagination.currentPage || 1"
        :disabled="loading"
        :layout="paginationLayout"
        :total="count"
        @current-change="doChangePaginationCurrentPage"
        @size-change="doChangePaginationPageSize"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { SeasonModel } from '@modules/season/season-model';
import { mapGetters, mapActions } from 'vuex';
import { SeasonPermissions } from '@modules/season/season-permissions';
import { AuditLogPermissions } from '@modules/audit-log/audit-log-permissions';
import { i18n } from '@shared/i18n';

const { fields } = SeasonModel;

export default {
  name: 'app-season-list-table',

  mounted() {
    this.doMountTable(this.$refs.table);
  },

  computed: {
    ...mapGetters({
      rows: 'season/list/rows',
      count: 'season/list/count',
      loading: 'season/list/loading',
      pagination: 'season/list/pagination',
      isMobile: 'layout/isMobile',
      currentUser: 'auth/currentUser',
      destroyLoading: 'season/destroy/loading',
      paginationLayout: 'layout/paginationLayout',
    }),

    hasPermissionToAuditLogs() {
      return new AuditLogPermissions(this.currentUser).read;
    },

    hasPermissionToEdit() {
      return new SeasonPermissions(this.currentUser).edit;
    },

    hasPermissionToDestroy() {
      return new SeasonPermissions(this.currentUser).destroy;
    },

    fields() {
      return fields;
    },
  },

  methods: {
    ...mapActions({
      doChangeSort: 'season/list/doChangeSort',
      doChangePaginationCurrentPage:
        'season/list/doChangePaginationCurrentPage',
      doChangePaginationPageSize:
        'season/list/doChangePaginationPageSize',
      doMountTable: 'season/list/doMountTable',
      doDestroy: 'season/destroy/doDestroy',
    }),

    presenter(row, fieldName) {
      return SeasonModel.presenter(row, fieldName);
    },

    async doDestroyWithConfirm(id) {
      try {
        await this.$confirm(
          i18n('common.areYouSure'),
          i18n('common.confirm'),
          {
            confirmButtonText: i18n('common.yes'),
            cancelButtonText: i18n('common.no'),
            type: 'warning',
          },
        );

        return this.doDestroy(id);
      } catch (error) {
        // no
      }
    },
  },
};
</script>

<style>
</style>
